import Vue from 'vue'
import store from './store'
import App from './App.vue'
import router from './router'
import './styles/main.scss'
import { apolloProvider } from './vue-apollo'
import ToastedPlugin from 'vue-toasted'

// @ts-ignore
import vueDebounce from 'vue-debounce'

Vue.config.productionTip = false

export const bus = new Vue()

Vue.use(ToastedPlugin, {
  duration: 3 * 1000,
  singleton: true,
  keepOnHover: true,
  position: 'top-center',
  theme: 'bubble'
})

Vue.use(vueDebounce, {
  defaultTime: '700ms',
  listenTo: ['input', 'keyup']
})

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
